import IllumioDomUtils from "../common/dom_utils.js";

const IllumioTrainingContent = {
    populateImage: function(prefix) {
        if (!prefix) return;

        const divElement = document.getElementById(prefix+'Div');
        const imageElement = document.getElementById(prefix+'Image');
        console.debug(divElement);
        console.debug(imageElement);
        if (divElement && imageElement) {
            IllumioDomUtils.removeChildren(divElement);
            if (divElement.appendChild(imageElement)) {
                imageElement.classList.remove('hidden');
            }
        }
    },
}

export default IllumioTrainingContent;
